import React from 'react';

import FormToggle from './FormToggle';
import BlockContent from './BlockContent';

export default function FormRow({
  title,
  description,
  example,
  buttons,
  name,
  value,
  handleChange,
  children
}) {
  const style = `form-row ${name ? '--with-toggle' : ''}`;
  return (
    <div className={style}>
      <BlockContent
        content={{
          headingTwo: title,
          headingThree: example,
          description: description,
          buttons: buttons
        }}
      />
      {name && <FormToggle name={name} value={value} onChange={handleChange} />}
      {children && children}
    </div>
  );
}
